export default "/imgs/tag/secretary.svg"